import React, { useState } from 'react';

import { connect } from 'react-redux';

import {
    Grid,
    GridNoRecords,
    GridColumn as Column,
} from '@progress/kendo-react-grid';
import { process as kendoProcess } from '@progress/kendo-data-query';

import BobLoadingMask from '../../../components/BobLoadingMask';

import * as classes from './EquipmentEnergyGrid.module.css';

const initialDataState = {
    sort: [],
    take: 10,
    skip: 0
};

const EquipmentEnergyGrid = ({
    bobLoading,
    data,
    entity,
    hasInitialized,
    workbookModeEnabled,
    ...props
}) => {
    const [dataState, setDataState] = useState(initialDataState);
    const [pageable] = useState({ pageSizes: true });

    const onDataStateChange = e => {
        setDataState(e.dataState);
    };

    const columns = [
        {
            field:      'equipmentName',
            title:      'Equipment',
            filter:     'text',
            id:         'equipmentName',
            width:      'auto',
            sortable:   true,
            filterable: true,
            show:       true,
            hidden:     false,
            orderIndex: 0,
            primaryKey: true
        },
        {
            field:      'clientName',
            title:      'Client',
            filter:     'text',
            width:      250,
            id:         'client',
            sortable:   true,
            filterable: true,
            show:       true,
            hidden:     false,
            orderIndex: 1
        },
        {
            field:      'sitename',
            title:      'Site',
            filter:     'text',
            width:      250,
            id:         'site',
            sortable:   true,
            filterable: true,
            show:       true,
            hidden:     false,
            orderIndex: 2
        },
        {
            field:      'equipmentType',
            title:      'Equipment Type',
            filter:     'text',
            width:      200,
            id:         'equipmentType',
            sortable:   true,
            filterable: true,
            show:       true,
            hidden:     false,
            orderIndex: 3
        },
        {
            field:      'area',
            title:      'Area',
            filter:     'text',
            width:      150,
            id:         'area',
            sortable:   true,
            filterable: true,
            show:       true,
            hidden:     false,
            orderIndex: 4
        },
        {
            field:      'totalEnergyUse',
            title:      'Energy Consumption (Kwh)',
            filter:     'text',
            width:      250,
            id:         'totalEnergyUse',
            sortable:   true,
            filterable: true,
            show:       true,
            hidden:     false,
            orderIndex: 5
        },
        {
            field:      'cost',
            title:      'Cost (USD)',
            filter:     'text',
            width:      150,
            id:         'cost',
            sortable:   true,
            filterable: true,
            show:       true,
            hidden:     false,
            orderIndex: 6
        },
        {
            field:      'costConversion',
            title:      'Carbon (lbs)',
            filter:     'text',
            width:      250,
            id:         'carbon',
            sortable:   true,
            filterable: true,
            show:       true,
            hidden:     false,
            orderIndex: 7
        },
    ];

    return (
        <div className={classes.Table}>
            <Grid
                sortable={{
                    mode: 'multiple'
                }}
                className={classes.KendoGrid}
                data={kendoProcess(data, dataState)}
                {...dataState}
                onDataStateChange={onDataStateChange}
                pageable={pageable}
                reorderable
                filterable={workbookModeEnabled}
            >
                {
                    !hasInitialized ?
                        <GridNoRecords>
                            {`Loading ${entity} energy records`}
                        </GridNoRecords>
                        :
                        <GridNoRecords>
                            {`No ${entity} energy records`}
                        </GridNoRecords>
                }
                {
                    columns.map((column, index) => (
                        <Column
                            field={column.field}
                            title={column.title}
                            key={index}
                            width={column.width}
                            sortable={column.sortable}
                            filterable={column.filterable}
                        />
                    ))
                }
            </Grid>
            {
                bobLoading.includes('FetchClientEnergyEquipment') || bobLoading.includes('FetchSiteEnergyEquipment') || !hasInitialized ?
                    <BobLoadingMask />
                    :
                    null
            }
        </div>
    );
};

const mapStateToProps = state => ({
    bobLoading:          state.bob.bobLoading,
    workbookModeEnabled: state.dashboard.workbookModeEnabled
});

export default connect(mapStateToProps, null)(EquipmentEnergyGrid);
